// extracted by mini-css-extract-plugin
module.exports = {"doc":"Docs_doc__Sq4OG"};